module.exports = __webpack_public_path__ + "img/tab2-1@2x.33228155.png";